export const ADD_NEW_DISCOUNT = 'ADD_NEW_DISCOUNT';
export const UPDATE_TRANSLATE_DISCOUNT = 'UPDATE_TRANSLATE_DISCOUNT';
export const LOAD_DISCOUNTS = 'LOAD_DISCOUNTS';
export const SET_DISCOUNT_FILTER = 'SET_DISCOUNT_FILTER';
export const SET_DISCOUNT_PAGINATION = 'SET_DISCOUNT_PAGINATION';
export const SET_DISCOUNT_SORT = 'SET_DISCOUNT_SORT';
export const RESET_DISCOUNT_FILTERS = 'RESET_DISCOUNT_FILTERS';
export const LOAD_EDITABLE_DISCOUNT = 'LOAD_EDITABLE_DISCOUNT';
export const EDIT_DISCOUNT = 'EDIT_DISCOUNT';
export const SET_EMPTY_EDITABLE_DISCOUNT = 'SET_EMPTY_EDITABLE_DISCOUNT';
